import React, { Component } from 'react';
import { Grid, Row, Col, Icon } from 'rsuite';

class Keynote3 extends Component {

    componentDidMount = () => {
        // console.log(this.props)
    }


  render() {
    return (
      <div className="r_container">
        <div className="home">
            <div className="new_banner">
            <div className="banner_content">
              <h1>LLM 2025</h1>
              
              <h6>The 2025 International Conference on Large Language Models (LLM)</h6>
              <h6>December 3-5, 2025, Las Vegas, USA</h6>
            </div>

            <div className="new_banner_overlay"></div>
          </div>
          

          <div className="page_content">
            <h4 className="par_header">Keynotes/Invited Lectures</h4>
            <br />
            <div style={{textAlign: "center"}}>
            <b>Building AI-Powered Business Systems: Architecture, Implementation, and Real-World Lessons
</b> <br/>
            <br />Karthik Nallani Chakravartula <br/>
            Farm Credit Bank, Austin, Texas, USA<br />
            </div>
        
            <h6 className="par_header">Abstract:</h6>
            <div className="par">
            The architecture for integrating AI into enterprise systems through our Dynamics 365 implementation will be presented. You'll see the technical foundation in NET microservices, React interfaces, Azure Fabric data pipelines, DevOps workflows, and security patterns—alongside practical insights about what succeeded and failed. Architectural wins included service-oriented design, component-based patterns, and incremental rollouts that built user trust and being honest about AI’s limitations increased adoption. We also made mistakes that cost us: building custom ML models seemed more sense on our use cases but it was rather resource and time intensive and not good ROI, rushing deployment backfired and we underestimated the change management effort The presentation provides reference architectures, code samples, testing strategies, and deployment templates, balanced with honest discussion of costs, timelines, and organizational challenges. This is comprehensive technical guidance with real-world validation from a system serving thousands daily. This uses Microsoft’s stack but the patterns apply to any cloud platform.
            </div>

            <h6 className="par_header">Speaker’s Biography:</h6>
            <div className="par">
            Karthik Nallani Chakravartula is a solution architect and senior software engineer with 15 years building production systems in the Microsoft ecosystem—Dynamics 365, Azure, Power Platform, and AI/data engineering. He leads enterprise projects from architecture to deployment, with experience spanning credit-risk decisioning, CRM modernization, analytics platforms, and workflow automation.
            <br/> <br/>
            He works across the full technical spectrum: designing architecture, writing production code, and ensuring teams can actually run what gets built. His specialty is converting ambiguous business requirements into systems that ship. Karthik regularly speaks at industry conferences and mentors practitioners on enterprise Software design and implementation.
            <br/> <br/>
            <div style={{textAlign: "center"}}>
                <img src="/static/Chakravartula.jpg" height="300px" alt=""/>
            </div>
            </div>          
          </div>
          

        </div>
      </div>
    );
  }
}

export default Keynote3;